export const APP_OPTIONS = [
	{ label: "Moments", value: 1 },
	{ label: "IKCATI", value: 2 },
];